import { atom } from 'recoil';

export const isTaxonomyValidState = atom({
    key: 'isTaxonomyValidState',
    default: false,
});
